import { inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiProviderService } from './api-provider.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { CustomerView, ICustomerViewDto } from '../models/customer-view-dto.model';
import { createRequestOption, mapAsBody } from '../app/shared/util/request-util';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';

@Injectable({ providedIn: 'root' })
export class CustomerService implements IBaryTableFetchService<ICustomerViewDto> {
  readonly #apiProvider = inject(ApiProviderService);

  private customerUrl = API_ENDPOINTS.CUSTOMER;
  private customerDataUrl = API_ENDPOINTS.CUSTOMER_DATA;

  private customerIdUrl = API_ENDPOINTS.CUSTOMER_ID;
  private initCustomerResourceUrl = API_ENDPOINTS.CUSTOMER_CURRENT;
  private customerUserInformationUrl = API_ENDPOINTS.CUSTOMER_ID_USER;
  private customerDeleteAliasUrl = API_ENDPOINTS.CUSTOMER_USER_ID_DELETE_ALIAS;

  public updateWithUserInformation(customer: CustomerView): Observable<CustomerView> {
    return this.#apiProvider.put<ICustomerViewDto>(this.customerUserInformationUrl(customer.id), customer.serialize()).pipe(
      mapAsBody,
      map((iCustomerViewDto: ICustomerViewDto) => new CustomerView(iCustomerViewDto))
    );
  }

  public find(id: number): Observable<CustomerView> {
    return this.#apiProvider.get<ICustomerViewDto>(this.customerIdUrl(id)).pipe(
      mapAsBody,
      map((iCustomerViewDto: ICustomerViewDto) => new CustomerView(iCustomerViewDto))
    );
  }

  public query(req?: any): Observable<HttpResponse<CustomerView[]>> {
    const options = createRequestOption(req);
    return this.#apiProvider.get<ICustomerViewDto[]>(this.customerUrl, { params: options, observe: 'response' }).pipe(
      map((res: HttpResponse<ICustomerViewDto[]>) => {
        return new HttpResponse<CustomerView[]>({
          body: (res.body || []).map(v => new CustomerView(v)),
          url: res.url as string,
          headers: res.headers,
          status: res.status,
        });
      })
    );
  }

  // /!\ PUBLIC
  public findCurrentCustomer(): Observable<ICustomerViewDto | undefined> {
    return this.#apiProvider.publicGet<ICustomerViewDto>(this.initCustomerResourceUrl()).pipe(mapAsBody);
  }

  public deleteAlias(id: number): Observable<CustomerView> {
    //TODO: A changer POST => DELETE
    return this.#apiProvider.post<ICustomerViewDto>(this.customerDeleteAliasUrl(id), undefined).pipe(
      mapAsBody,
      map((iCustomerViewDto: ICustomerViewDto) => new CustomerView(iCustomerViewDto))
    );
  }

  public fillDataToShow(entities: ICustomerViewDto[]): Observable<ICustomerViewDto[]> {
    return of(entities);
  }

  public hasIncompleteData(): Observable<boolean> {
    return this.#apiProvider.publicGet<boolean>(this.customerDataUrl).pipe(map(httpResponse => httpResponse.body ?? false));
  }
}
